import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { AppContextProvider } from '../AppLoader';
import { EmailCodeDialog } from '../EmailCodeDialog/EmailCodeDialog';
import {
  PoliciesContainer,
  PoliciesVerticalContainer,
} from '../PoliciesContainer';

/** The code step of an email-code signup. */
const SignupEmailCodeDialog: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: {
      signupEmailFactorStore,
      displayStore: { policiesOutsideCard },
    },
  } = useContext(AppContextProvider);
  // Same contract as the signup form: the preset may move the terms below the card.
  const policies = <PoliciesContainer.Expanded />;

  return (
    <EmailCodeDialog
      store={signupEmailFactorStore}
      pageName="login-react-app.signup-email-code"
      dataHookPrefix="signup.emailCode"
      submitLabel={t('signup.submit')}
      passwordLabel={t('signup.email_code.choose_password', {
        defaultValue: 'Choose a Password',
      })}
      belowCard={policiesOutsideCard ? policies : null}
      // The modal header's back goes back in history, as on the other signup
      // screens.
      shouldGoBackToEmailInModal={false}
    >
      {!policiesOutsideCard && (
        <PoliciesVerticalContainer>{policies}</PoliciesVerticalContainer>
      )}
    </EmailCodeDialog>
  );
});

export default SignupEmailCodeDialog;
